import { useMemo } from 'react'
import { numberFormat } from 'shared/util'
import {
  Card, CardActionArea, CardMedia, CardProps,
  Chip, Typography, Box, Grid,
	GridProps
} from '@mui/material'

import { SearchResult, SearchStatus } from 'interface/search'
import { ValueSpan } from 'components/controls/valueSpan'

type SisetuSearchResultBlockProps = {
	search: SearchResult
	openSisetu: () => void
} & CardProps
const SisetuSearchResultBlock = ({
	search,
	openSisetu,
	...others
}: SisetuSearchResultBlockProps) => {
	const disabled = useMemo(
		() => search.status !== SearchStatus.Finished || (search.sisetuCount ?? 0) === 0,
		[search]
	)
	return (
		<Card {...others}>
			<CardActionArea onClick={openSisetu} disabled={disabled}>
				<Box position="relative">
					<Box
						position="absolute"
						top={4} left={8}
					>
						<Typography
							variant="h6"
							color={disabled ? "gray" : "white"}
							component="div"
							sx={{ textShadow: '1px 1px 3px #000000' }}
						>
							施設分析
						</Typography>
					</Box>

					<Box
						position="absolute"
						bottom={8} right={8}
						bgcolor="rgba(255,255,255,0.6)"
						paddingX={1.5}
						paddingY={0.5}
						borderRadius={1}
					>
						{(search.sisetuCount && search.sisetuCount > 0) ? (
							<ValueSpan text={numberFormat(search.sisetuCount)} suffix="施設"/>
						) : (
							<Chip label="対象なし" variant="filled" color="default" size="small"/>
						)}
					</Box>

					<CardMedia
						component="img"
						sx={{
							opacity: ((search.sisetuCount ?? 0) > 0) ? 1 : 0.5,
							height: "12em"
						}}
						image="/sisetu.jpg"
						alt="施設分析"
					/>
				</Box>
			</CardActionArea>
		</Card>
	)
}

type KojinSearchResultBlockProps = {
	search: SearchResult
	openKojin: () => void
} & CardProps
const KojinSearchResultBlock = ({
	search,
	openKojin,
	...others
}: KojinSearchResultBlockProps) => {
	const disabled = useMemo(
		() => search.status !== SearchStatus.Finished || (search.kojinCount ?? 0) === 0,
		[search]
	)
	return (
		<Card {...others}>
			<CardActionArea onClick={openKojin} disabled={disabled}>
				<Box position="relative">
					<Box
						position="absolute"
						top={4} left={8}
					>
						<Typography
							variant="h6"
							color={disabled ? "gray" : "white"}
							component="div"
							sx={{ textShadow: '1px 1px 2px #000000' }}
						>
							KOL分析
						</Typography>
					</Box>

					<Box
						position="absolute"
						bottom={8} right={8}
						bgcolor="rgba(255,255,255,0.6)"
						paddingX={1.5}
						paddingY={0.5}
						borderRadius={1}
					>
						{(search.kojinCount && search.kojinCount > 0) ? (
							<ValueSpan text={numberFormat(search.kojinCount)} suffix="人"/>
						) : (
							<Chip label="対象なし" variant="filled" color="default" size="small"/>
						)}
					</Box>

					<CardMedia
						component="img"
						sx={{
							opacity: ((search.kojinCount ?? 0) > 0) ? 1 : 0.5,
							height: "12em"
						}}
						image="/kojin.jpg"
						alt="KOL分析"
					/>
				</Box>
			</CardActionArea>
		</Card>
	)
}

type GridBlockProps = {
	search: SearchResult
	openGrid: () => void
} & CardProps
const GridBlock = ({
	search,
	openGrid,
	...others
}: GridBlockProps) => {
	const disabled = useMemo(
		() => search.status !== SearchStatus.Finished || (search.kojinCount ?? 0) === 0,
		[search]
	)
	return (
		<Card {...others}>
			<CardActionArea onClick={openGrid} disabled={disabled}>
				<Box position="relative">
					<Box
						position="absolute"
						top={4} left={8}
					>
						<Typography
							variant="h6"
							color={disabled ? "gray" : "white"}
							component="div"
							sx={{ textShadow: '1px 1px 2px #000000' }}
						>
							シート分析
						</Typography>
					</Box>

					<CardMedia
						component="img"
						sx={{
							opacity: ((search.kojinCount ?? 0) > 0) ? 1 : 0.5,
							height: "12em"
						}}
						image="/grid.jpg"
						alt="シート分析"
					/>
				</Box>
			</CardActionArea>
		</Card>
	)
}

type SearchResultBlocksProps = {
	search: SearchResult
  openSisetu: () => void
  openKojin: () => void
  openGrid: () => void
} & GridProps
export const SearchResultBlocks = ({
	search,
	openSisetu,
	openKojin,
	openGrid,
	...others
}: SearchResultBlocksProps) => {
	return (
		<Grid container spacing={1} {...others}>
			<Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 3 }}>
				<SisetuSearchResultBlock search={search} openSisetu={openSisetu}/>
			</Grid>
			<Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 3 }}>
				<KojinSearchResultBlock search={search} openKojin={openKojin}/>
			</Grid>
			<Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 3 }}>
				<GridBlock search={search} openGrid={openGrid}/>
			</Grid>
		</Grid>
	)
}